module.exports = __webpack_public_path__ + "img/DSC00637.ddbd2344.JPG";